import React, { useEffect, useState } from "react";
import { ApprovalZone } from "components/FormElements/ApprovalZone/ApprovalZone.js";

export const MaintenanceModal = ({ nhsBsaMaintenance, onConfirm }) => {
    const downtimeReason = nhsBsaMaintenance.downtimeReason;
    const maintenanceMessage = `The NHS submission service is currently unavailable. Your submission cannot be processed at this time. We apologise for the inconvenience. Please try again once the service is restored.`;
    return (
        <ApprovalZone
            headerText="Submission Not Possible"
            redText={maintenanceMessage}
            onConfirmText="OK"
            areYouSureText=" "
            reason={downtimeReason}
            onConfirm={onConfirm}
            onDecline={() => {}}
            hideDecline={true}
        />
    );
};
